import { Stack, Typography } from '@mui/material';
import { IntermediateNpsFuncValue } from 'generated/graphql';

interface NPSFormulaDefinitionParams {
  nps: IntermediateNpsFuncValue & {
    value: number;
  };
}

export function NPSFormulaDefinition({ nps }: NPSFormulaDefinitionParams) {
  return (
    <Stack>
      <Typography variant="caption">
        Net Promoter Score (NPS):{' '}
        <Typography component="span" variant="inherit" fontWeight="bold">
          {nps.value}
        </Typography>
      </Typography>
      <Typography variant="caption">
        {`% Promoters (NPS > 8) `}
        <Typography component="span" variant="inherit" fontWeight="bold">
          {nps.promotersPercentage}%
        </Typography>
        {` - Detractors (NPS < 7) `}
        <Typography component="span" variant="inherit" fontWeight="bold">
          {nps.detractorsPercentage}%
        </Typography>
      </Typography>
    </Stack>
  );
}
